import { getTicket } from '@/ticket/api/get-ticket';
import { useSuspenseQuery } from '@tanstack/react-query';

export function useTicket(ticketKey: string) {
  const { data, ...query } = useSuspenseQuery({
    queryKey: ['ticket', ticketKey],
    queryFn: () => getTicket({ key: ticketKey }),
  });
  return { ticket: data, ...query };
}
